const COUNTRY_LABELS = {
  sn: {
    taxSharesLabelKey: 'countryLabels.sn'
  },
  ci: {
    taxSharesLabelKey: 'countryLabels.ci'
  },
  ne: {
    taxSharesLabelKey: 'countryLabels.ne'
  },
  cm: {
    taxSharesLabelKey: 'countryLabels.cm'
  }
};

export const getCountryLabel = (country) => {
  return COUNTRY_LABELS[country] || COUNTRY_LABELS.sn;
};